import React, { useEffect } from "react";
import styled from "styled-components";
import iconTeamCode from "../../../../../assets/images/Event-2024/Group (7).png";

export default function AnimationAddCode({
  numberAdd = 0,
  setTotalNumberAddCode,
}) {
  useEffect(() => {
    if(!numberAdd){
      return;
    }
    const timeout = setTimeout(() => {
      setTotalNumberAddCode(0);
    }, 3100);
    return () => clearTimeout(timeout);
  }, [numberAdd]);

  if (!numberAdd) {
    return;
  }
  return (
    <Div>
      <img src={iconTeamCode} alt="" />
      <div className="team-code-add">{numberAdd}</div>
    </Div>
  );
}

const Div = styled.div`
  position: absolute;
  z-index: 999;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  animation: fly-to-corner 3s ease-in-out forwards;
  pointer-events: none;

  .team-code-add {
    position: absolute;
    left: 50%;
    top: calc(50% + 11px);
    transform: translate(-50%, -50%);
    font-size: 24px;
    font-weight: bold;
  }

  @keyframes fly-to-corner {
    0% {
      opacity: 1;
      scale: 1;
    }
    95% {
      /* opacity: 1; */
      scale: 0.8;
    }
    100% {
      opacity: 0;
      display: none;
      scale: 0.8;
    }
  }
`;
